import { Framework } from '@vechain/connex-framework';
import { genesisBlocks } from './config';
import { compat1 } from './compat';
import { createFull, DriverVendorOnly } from './driver';
import { newVendor } from '@vechain/connex-framework';
/** convert options.network to Connex.Thor.Block */
function normalizeNetwork(n) {
    n = n || 'main';
    if (typeof n === 'string') {
        const gb = genesisBlocks[n];
        if (!gb) {
            throw new Error('invalid network');
        }
        return gb;
    }
    else {
        return n;
    }
}
/** convert network name to genesis id */
function normalizeGenesisId(id) {
    id = id || 'main';
    if (/^0x[0-9a-f]{64}$/.test(id)) {
        return id;
    }
    const gb = genesisBlocks[id];
    if (gb) {
        return gb.id;
    }
    throw new Error('invalid genesis id');
}
/** Vendor class which can work standalone to provides signing-services only */
class VendorClass {
    constructor(genesisId, opts) {
        genesisId = normalizeGenesisId(genesisId);
        if (!(opts && opts.noV1Compat)) {
            try {
                // to detect injected connex
                const injected = window.connex;
                if (injected && injected.thor.genesis.id === genesisId) {
                    // injected genesis id matched
                    if (/^1\./.test(injected.version)) {
                        // wrap v1 vendor to v2
                        return compat1(injected).vendor;
                    }
                }
            }
            catch ( /**/_a) { /**/ }
        }
        // detect the extension injected vechain
        const useExtension = !(opts && opts.noExtension) && !!window.vechain;
        const driver = new DriverVendorOnly(genesisId, useExtension);
        const vendor = newVendor(driver);
        return {
            get sign() {
                return vendor.sign.bind(vendor);
            }
        };
    }
}
/** Connex class */
class ConnexClass {
    constructor(opts) {
        const genesis = normalizeNetwork(opts.network);
        if (!opts.noV1Compat) {
            try {
                // to detect injected connex
                const injected = window.connex;
                if (injected && injected.thor.genesis.id === genesis.id) {
                    // injected genesis id matched
                    if (/^1\./.test(injected.version)) {
                        // wrap v1 to v2
                        return compat1(injected);
                    }
                }
            }
            catch ( /**/_a) { /**/ }
        }
        // detect the extension injected vechain
        const useExtension = !opts.noExtension && !!window.vechain;
        const driver = createFull(opts.node, genesis, useExtension);
        const framework = new Framework(driver);
        return {
            get thor() { return framework.thor; },
            get vendor() { return framework.vendor; }
        };
    }
}
ConnexClass.Vendor = VendorClass;
export default ConnexClass;
export { ConnexClass as Connex };
//# sourceMappingURL=data:application/json;base64,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